// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../reason/next/Next.bs.js");
var Link = require("next/link").default;
var FeaturesV3 = require("../reason/featureFlipper/FeaturesV3.bs.js");
var AuthSession = require("../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var MarkupHelpers = require("../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function TopNav$NavLink(props) {
  var mobileNavToggle = props.mobileNavToggle;
  var href = props.href;
  var router = Next.useRouter();
  var pathname = Next.Router.pathname(router);
  var firstSeg = function (s) {
    return Core__Option.getOr(s.split("/")[1], "");
  };
  var isActive = firstSeg(pathname) === "conversations" && firstSeg(pathname) === firstSeg(href) || pathname === href;
  var linkClass = TailwindMerge.twMerge([
        "text-lg leading-6 block text-zinc-300 bg-tan-big-stone-alt hover:no-underline hover:text-tan-old-lace focus:text-tan-aqua-haze sm:text-lg sm:leading-7 sm:px-4 sm:inline-block sm:bg-tan-big-stone",
        isActive ? "text-tan-old-lace font-semibold" : "",
        props.isFirst ? "sm:pl-0" : ""
      ]);
  var spanClass = TailwindMerge.twMerge([
        "inline-block py-3 px-3.5 border-l-4 border-solid border-transparent sm:py-2.5 sm:px-0 sm:border-l-0 sm:border-b-2 sm:border-transparent mb-0.5",
        isActive ? "border-l-tan-gold-light sm:border-b-tan-gold-light" : ""
      ]);
  return JsxRuntime.jsx(Link, {
              href: href,
              className: linkClass,
              children: Caml_option.some(JsxRuntime.jsx("span", {
                        children: props.text,
                        className: spanClass
                      })),
              onClick: (function (_evt) {
                  mobileNavToggle();
                })
            });
}

var NavLink = {
  make: TopNav$NavLink
};

function TopNav$LoggedIn(props) {
  var mobileNavToggle = props.mobileNavToggle;
  var agentLinks = [
    {
      href: "/",
      text: "Home"
    },
    {
      href: "/me",
      text: "My Dashboard"
    },
    {
      href: "/conversations",
      text: "Conversations"
    },
    {
      href: "/chapter",
      text: "Chapter Activity"
    }
  ];
  var clientLinks = [{
        href: "/client",
        text: "Home"
      }].concat(props.showSavedSearchNavItem ? [{
            href: "/client/saved-searches",
            text: "Saved Searches"
          }] : []);
  var links = props.userRole === "agent" ? agentLinks : clientLinks;
  return JsxRuntime.jsx("ul", {
              children: links.map(function (param, index) {
                    var href = param.href;
                    return JsxRuntime.jsx("li", {
                                children: JsxRuntime.jsx(TopNav$NavLink, {
                                      href: href,
                                      text: param.text,
                                      mobileNavToggle: mobileNavToggle,
                                      isFirst: index === 0
                                    })
                              }, href);
                  }),
              className: "p-0 list-none flex flex-col m-0 -mx-4 sm:mx-0 divide-y sm:divide-y-0 divide-tan-big-stone-dark sm:flex-row"
            });
}

var LoggedIn = {
  make: TopNav$LoggedIn
};

function TopNav(props) {
  var savedSearchEnabled = FeaturesV3.useSavedSearchesEnabled();
  var clientInfo = UserSession.useClientInfoOpt();
  var userIsClientWithAutonotifyBuyerNeed = clientInfo !== undefined ? clientInfo.agentBuyerNeed !== undefined : false;
  var currentUserRole = AuthSession.useCurrentUserRole();
  if (currentUserRole === undefined) {
    return null;
  }
  var tmp;
  tmp = currentUserRole === "AGENT" ? "agent" : "client";
  return JsxRuntime.jsx("section", {
              children: JsxRuntime.jsx(MarkupHelpers.Container.make, {
                    children: JsxRuntime.jsx(TopNav$LoggedIn, {
                          userRole: tmp,
                          showSavedSearchNavItem: savedSearchEnabled || userIsClientWithAutonotifyBuyerNeed,
                          mobileNavToggle: props.mobileNavToggle
                        })
                  }),
              className: "bg-tan-big-stone"
            });
}

var make = TopNav;

exports.NavLink = NavLink;
exports.LoggedIn = LoggedIn;
exports.make = make;
/* Next Not a pure module */
